// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"not-found_wrapper__2LGO4","text":"not-found_text__pCRSD","row":"not-found_row__1aUJ9"};